import React, { useEffect, useState } from 'react';
import { useMutation } from 'react-query';
import {
  Paper,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
} from '@mui/material';
import client from '../../../../../API';

const headerSx = {
  '& th': { bgcolor: 'grey.100', color: 'text.primary', fontWeight: 600 },
};

const FinancialsKPI = () => {
  const [invoiceData, setInvoiceData] = useState({});

  const { mutate: fetchInvoices } = useMutation(client.invoices.listKPI, {
    onSuccess: setInvoiceData,
  });

  useEffect(fetchInvoices, []);

  /* ---- sort by week (string → Date) DESC ---- */
  const sorted = Object.entries(invoiceData).sort(
    (a, b) => new Date(b[0]) - new Date(a[0])
  );

  return (
    <Paper elevation={2}>
      <TableContainer>
        <Table stickyHeader>
          <TableHead sx={headerSx}>
            <TableRow>
              <TableCell>Week Starting</TableCell>
              <TableCell>Paid</TableCell>
              <TableCell>Sent</TableCell>
              <TableCell>Pending</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {sorted.map(([week, d]) => (
              <TableRow key={week}>
                <TableCell>{week}</TableCell>
                <TableCell>{d.Paid}</TableCell>
                <TableCell>{d.Sent}</TableCell>
                <TableCell>{d.Pending}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default FinancialsKPI;
